import { Routes } from '@angular/router';
import { Layout } from './layout/layout';
import { Login } from './features/login/login';
import { AuthCallback } from './features/auth-callback/auth-callback';
import { authGuard } from './core/guards/auth-guard';
import { homeRedirectGuard } from './core/guards/home-redirect.guard';

export const routes: Routes = [
    {
        path: 'login',
        component: Login,
    },
    {
        path: 'auth/callback',
        component: AuthCallback
    },
    {
        path: '',
        component: Layout,
        canActivate: [authGuard],
        children: [
            // {
            //     path: 'dashboard',
            //     loadComponent: () => import('./features/dashboard/dashboard').then(m => m.Dashboard)
            // },
            {
                path: 'role-region',
                loadComponent: () => import('./features/role-region/role-region').then(m => m.RoleRegion)
            },
            {
                path: 'lookups',
                loadComponent: () => import('./features/lookups/lookups').then(m => m.Lookups)
            },
            {
                path: 'mass-upload',
                loadComponent: () => import('./features/mass-upload/mass-upload').then(m => m.MassUpload)
            },
            {
                path: 'dm-sale-dashboard',
                loadComponent: () => import('./features/dm-sale-dashboard/dm-sale-dashboard').then(m => m.DmSaleDashboard)
            },
            {
                path: 'claim-list',
                loadComponent: () => import('./features/claim-list/claim-list').then(m => m.ClaimList)
            },
            {
                path: 'task-list',
                loadComponent: () => import('./features/task-list/task-list').then(m => m.TaskList)
            },
            {
                path: 'approval-matrix',
                loadComponent: () => import('./features/approval-matrix/approval-matrix').then(m => m.ApprovalMatrix)
            },
            {
                path: 'notification-matrix',
                loadComponent: () => import('./features/notification-matrix/notification-matrix').then(m => m.NotificationMatrix)
            },
            {
                path: 'approval-reassign',
                loadComponent: () => import('./features/approval-reassignment/approval-reassignment').then(m => m.ApprovalReassignment)
            },
            {
                path: 'admin-claims',
                loadComponent: () => import('./features/admin-claims/admin-claims').then(m => m.AdminClaims)
            },
            {
                path: '',
                canActivate: [homeRedirectGuard],
                children: []
            }
        ]
    },
    { path: '**', redirectTo: '/login' }
];